import { metaHelper } from '@customerio/dryad';
import { createBuilderHook } from '@customerio/dryad-react';
import { PEOPLE_FILTER_FORMAT, PEOPLE_FILTER_MAX_DEPTH, peopleFilterAdapter } from './people-filter-format';

// Views are registered in people-filter-builder.tsx, not here: a row needs
// this builder for its typed useMeta/useLeafState reads, so importing rows
// into this module would be circular.

export type TypeOption = { value: string; label: string };
export type TypeOptionGroup = { label: string; options: TypeOption[] };

export type PeopleFilterBuilderMeta = {
  /**
   * Locks every control. Derived per render from the host's disabled prop and
   * the attribute lock (a user who can't view attribute values can't touch a
   * filter that holds an attribute condition anywhere in the tree).
   */
  isDisabled: boolean;
  /**
   * The add/change condition menu, already intersected with the workspace
   * gates (no device conditions without push enabled, opt_out only with a
   * configured SMS/WhatsApp sender) so the menu tracks the same gates on
   * every consumer.
   */
  typeOptions: TypeOptionGroup[];
  /** Redaction: the attribute row disables its inputs when false. */
  canViewAttributeValues: boolean;
};

export const peopleFilterBuilder = createBuilderHook({
  formatAdapters: { [PEOPLE_FILTER_FORMAT]: peopleFilterAdapter },
  maxDepth: PEOPLE_FILTER_MAX_DEPTH,
  meta: metaHelper<PeopleFilterBuilderMeta>(),
});
